import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';

import {isEmptyArray} from 'shared/utils';
import {areRequiredQueryParamsPresent} from 'shared/utils/metadata';
import {useQueryParams} from 'shared/utils/query-params';

interface IUseRequiredQueryParamsArgs {
    requiredQueryParams?: string[];
}

/**
 * Хук для проверки наличия обязательных query-параметров в URL.
 *
 * @param {string[]} requiredQueryParams - Массив обязательных query-параметров.
 *
 * @returns {{ isDisabled: boolean }}
 *   - isDisabled: true если отсутствует хотя бы один обязательный параметр, иначе false.
 *
 * @remarks
 * - Реагирует на изменения query-строки (использует location.search из react-router).
 * - Если requiredQueryParams пуст, параметры считаются валидными (isDisabled = false).
 */
export const useRequiredQueryParams = ({
    requiredQueryParams,
}: IUseRequiredQueryParamsArgs) : { isDisabled: boolean } => {
    const [isDisabled, setIsDisabled] = useState(false);
    const location = useLocation();
    const {getQueryParam} = useQueryParams();

    useEffect(() => {
        if (!isEmptyArray(requiredQueryParams)) {
            const arePresent = areRequiredQueryParamsPresent({
                requiredQueryParams,
                getQueryParam,
            });
            setIsDisabled(!arePresent);
        }
    }, [location.search]);

    return {isDisabled};
};
